// 調整班表
import * as types from '../actionType';

let initState = {
  events: [],
};

function AdjustmentScheduleState(state = initState, action) {
  switch (action.type) {
      case types.ADJUSTMENT_SCHEDULE_SHEET_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default AdjustmentScheduleState;